import React, { Component } from "react"

/* Icons */
import { CaretDownOutlined } from '@ant-design/icons'

/* Constants */
import { env, utils } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"

/* Moment */
import moment from "moment"
import 'moment/locale/ru'
moment.locale('ru')


/* Component History */
class History extends Component {

    constructor() {
        super()

        this.state = {
            active: -1
        }
    }


    /* JACKPOT | бэкенд помечает строку bonus словом jackpot, когда рояль флеш забрал весь пул */
    _jackpot = item => {

        if (!item || !Array.isArray(item.processes)) return null

        const process = item.processes.find(e => e.type === "bonus" && String(e.result) === "jackpot")

        if (!process) return null

        let currency = "USD"

        if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
            currency = item.transactions[0].currency
        }

        return { total: parseFloat(process.win || 0), currency, box: process.box }
    }


    /* Determine and draw total */
    _total = data => {

        let total = 0
        let currency = "USD"

        if (data.transactions && Array.isArray(data.transactions) && data.transactions.length > 0) {

            data.transactions.forEach(transaction => {

                if (transaction.type === 'credit') {
                    total = total + parseFloat(transaction.total)
                }

                if (transaction.type === 'debit') {
                    total = total - parseFloat(transaction.total)
                }

                currency = transaction.currency

            })

        }

        if (total > 0) {
            return <div className="history-head-total">+ {utils.convertor(Math.abs(total), currency)}</div>
        }

        if (total < 0) {
            return <div className="history-head-total">- {utils.convertor(Math.abs(total), currency)}</div>
        }

        return <div className="history-head-total">{utils.convertor(total, currency)}</div>
    }


    /* Draw time */
    _time = data => {

        if (data.createdAt) {

            const date = moment(data.createdAt).format("YYYY-MM-DD")
            const today = moment(new Date()).format("YYYY-MM-DD")

            const yesterdayD = new Date()
            yesterdayD.setDate(yesterdayD.getDate() - 1)
            const yesterday = moment(yesterdayD).format("YYYY-MM-DD")

            let text = date

            if (moment(date).isSame(today, 'day')) {
                text = 'Сегодня'
            }

            if (moment(date).isSame(yesterday, 'day')) {
                text = 'Вчера'
            }

            return (
                <div className="history-head-datetime">
                    <div className="history-head-time">{moment(data.createdAt).format("HH:mm")}</div>
                    <div className="history-head-date">{text}</div>
                </div>
            )
        }
    }


    /* Draw cards */
    _cards = (results, cards) => {

        let dealerGame = null
        let playerGameOne = null
        let playerGameTwo = null

        let dealerCards = []
        let playerBoxOne = []
        let playerBoxTwo = []

        if (Array.isArray(cards) && cards.length > 0) {
            results.forEach(result => {
                if (result.type === "dealer") {
                    dealerGame = result
                }
                if (result.type === "player") {
                    if (parseInt(result.box) === 1) {
                        playerGameOne = result
                    }
                    if (parseInt(result.box) === 2) {
                        playerGameTwo = result
                    }
                }
            })
        }

        if (Array.isArray(cards) && cards.length > 0) {

            cards.forEach(card => {
                if (card.type === "dealer") {
                    dealerCards.push(card)
                }
                if (card.type === "player") {
                    if (parseInt(card.box) === 1) {
                        playerBoxOne.push(card)
                    }
                    if (parseInt(card.box) === 2) {
                        playerBoxTwo.push(card)
                    }
                }
            })
        }

        return (
            <div className="modal-boxes">

                <div className="modal-box-item">
                    {dealerCards.length > 0 ? <div className="modal-box-text">Дилер</div> : null}
                    {dealerGame !== null ? <p>{dealerGame.result} [ {dealerGame.multiplier} : 1 ] </p> : null}
                    <div className="modal-cards">
                        {dealerCards.map((card, index) =>
                            <div key={`${index}`} className="modal-card-item">
                                <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                <span>{card.status === "buy" ? "BUY" : ""} </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal-box-item">
                    {playerBoxOne.length > 0 ? <div className="modal-box-text">Игрок (BOX - 1)</div> : null}
                    {playerGameOne !== null ? <p>{playerGameOne.result} [ {playerGameOne.multiplier} : 1 ] </p> : null}
                    <div className="modal-cards">
                        {playerBoxOne.map((card, index) =>
                            <div key={`${index}`} className="modal-card-item" style={{ opacity: card.status === "hidden" ? 0.5 : 1 }}>
                                <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                <span>{card.status === "exchange" ? "EXC" : card.status === "sixth" ? "6-TH" : card.status === "fifth" ? "5-TH" : ""}</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal-box-item">
                    {playerBoxTwo.length > 0 ? <div className="modal-box-text">Игрок (BOX - 2)</div> : null}
                    {playerGameTwo !== null ? <p>{playerGameTwo.result} [ {playerGameTwo.multiplier} : 1 ] </p> : null}
                    <div className="modal-cards">
                        {playerBoxTwo.map((card, index) =>
                            <div key={`${index}`} className="modal-card-item" style={{ opacity: card.status === "hidden" ? 0.5 : 1 }}>
                                <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                <span>{card.status === "exchange" ? "EXC" : card.status === "sixth" ? "6-TH" : card.status === "fifth" ? "5-TH" : ""}</span>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        )

    }


    /* Draw current game */
    _currentGame = () => {

        /* Props and state */
        const { info, transactions } = this.props
        const { active } = this.state

        if (info && (transactions && Array.isArray(transactions) && transactions.length > 0)) {
            return (
                <div className="history-item">

                    <div onClick={() => this.setState({ active: active === 'current' ? -1 : 'current' })} className={`history-head ${'current' === active ? 'history-active-head' : ''}`}>
                        <div className="history-number">Игра #{info.number} <div> (ТЕКУЩАЯ ИГРА)</div></div>
                        <CaretDownOutlined />
                    </div>

                    <div className={`history-hidden-box ${'current' === active ? 'history-hidden-box-active' : ''}`}>

                        <div className="history-transactions">
                            <div className="history-transaction-text">Транзакции</div>
                            {transactions.map((transaction, tk) =>
                                <div className="history-transaction-item" key={`${tk}`}>
                                    <div className="history-transaction-reason">{transaction.reason} {(transaction.box && parseInt(transaction.box) > 0) ? `(BOX ${transaction.box})` : ''}</div>
                                    <div className={`history-transaction-price ${transaction.type === 'credit' ? 'history-transaction-green-price' : ''}`}> {transaction.type === 'credit' ? "+" : "-"} {utils.convertor(transaction.total, transaction.currency)}</div>
                                    <div className="history-transaction-time">{moment(transaction.createdAt).format("Do MMM YYYY, hh:mm")}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        }

        return null
    }

    /* Admin refund list */
    adminRefundList = (item) => {

        if (item.processes && Array.isArray(item.processes) && item.processes.length > 0) {

            let currency = "USD"

            if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
                currency = item.transactions[0].currency
            }

            const list = item.processes.filter((e) => e.box === "all")

            if (list && list.length > 0) {
                return (
                    <div className="history-operations refunds">
                        <table className="operations-table">
                            <thead>
                                <tr>
                                    <th className="table-first">Вид</th>
                                    <th>Сумма</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    list.map((process, ind) => {
                                        return (
                                            <tr key={`h-o-${ind}`} className={`item`}>
                                                <td>{process.reason}</td>
                                                <td className="value">{utils.convertor(process.total ? process.total : 0, currency)}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                )
            }

            return null

        }

        return null

    }

    /* Operations list */
    operationsList = item => {

        if (item.processes && Array.isArray(item.processes) && item.processes.length > 0) {

            let total = 0
            let currency = "USD"
            let isRefundPaid = false

            let totalWin = 0

            if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
                currency = item.transactions[0].currency
                item.transactions.forEach(transaction => {
                    if (transaction.type === 'credit') {
                        totalWin += parseFloat(transaction.total)
                    }
                })
            }


            item.processes.forEach(item => {

                if (item.total) {
                    if (["payment", "refund"].includes(item.type)) {
                        isRefundPaid = true
                    } else if (item.type !== "maxpay") {
                        total += parseFloat(item.total)
                    }
                }
            })

            let gameProcesses = [[], []]
            const boxes = [1, 2]
            let array = item.processes
            boxes.forEach((box, index) => {
                gameProcesses[index] = array.filter((e) => parseInt(e.box) === parseInt(box))
            })

            return (
                <div className="history-operations">
                    <table className="operations-table">
                        <thead>
                            <tr>
                                <th className="table-first"></th>
                                <th>Вид ставки</th>
                                <th>Cтавка</th>
                                <th>Выигрыш</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                gameProcesses.map((array, ind) => {
                                    if (array.length > 0) {
                                        return array.map((item, index) => {
                                            /* Бонус, забравший пул, подсвечиваем золотом отдельно от обычного maxpay */
                                            const isJackpotRow = item.type === 'bonus' && String(item.result) === 'jackpot'
                                            const processStyle = isJackpotRow ? 'bonus-jackpot' : item.type === 'maxpay' ? 'gold' : item.type === 'pass' ? 'pass' : ''

                                            if (item.type === 'maxpay') {
                                                return (
                                                    <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                                        <td colSpan={3}>{`Вам выплатили максимальную сумму - ${utils.convertor(item.total, currency)}`}</td>
                                                    </tr>
                                                )
                                            }

                                            return (
                                                <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                                    {index === 0 ? <td className="table-first" rowSpan={array.length}>{`BOX - ${ind + 1}`}</td> : null}
                                                    <td>{item.reason}{isJackpotRow ? <span className="jackpot-mark">JACKPOT</span> : null}</td>
                                                    <td>{utils.convertor(item.total, currency)}</td>
                                                    <td className="value">{utils.convertor(item.win ? item.win : 0, currency)}</td>
                                                </tr>
                                            )
                                        })
                                    }

                                    return null

                                })
                            }

                            <tr key={`h-o-total`}>
                                <td className="table-first"></td>
                                <td>Итого</td>
                                <td className="total">{utils.convertor(Math.abs(total), currency)}</td>
                                <td className="total">{utils.convertor(Math.abs(isRefundPaid ? 0 : totalWin), currency)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            )
        }

        return null
    }

    render = () => {

        /* Props and state */
        const { visible, close, histories, loadMore, historyHasMore, always } = this.props
        const { active } = this.state

        /* Fields */
        const animated = visible ? 'animated' : ''
        const bottomStyle = histories.length > 10 ? 'initial' : ''


        return (
            <div className={`modal history ${always} ${animated}`}>
                <div className='modal-content'>

                    {/* Modal Header */}
                    <div className='modal-header'>
                        История игры
                        <div onClick={() => close()} className="modal-close">
                            <Picture src={`${env.mediapoint}/images/x.png`} alt="CLOSE" />
                        </div>
                    </div>

                    {/* Modal Body */}
                    <div className='modal-body'>

                        {/* The current game */}
                        {this._currentGame()}

                        {/* Old games */}
                        {histories.map((item, index) => {

                            let endBalance = parseFloat(item.startBalance)

                            /* JACKPOT | раунд, в котором игрок забрал пул */
                            const jackpot = this._jackpot(item)

                            return (
                                <div className={`history-item ${jackpot ? 'history-jackpot' : ''}`} key={`${index}`}>

                                    {/* Draw history head */}
                                    <div onClick={() => this.setState({ active: active === index ? -1 : index })} className={`history-head ${index === active ? 'history-active-head' : ''}`}>

                                        <div className="history-number">
                                            Игра #{item.number}
                                            {jackpot ? <span className="history-jackpot-badge"><span className="full">JACKPOT</span><span className="short">J</span></span> : null}
                                            {/* {index === 0 && <div className="history-number-text"> (LAST GAME)</div>} */}
                                        </div>

                                        <div className="history-head-right">
                                            {this._total(item)}
                                            {this._time(item)}
                                            <CaretDownOutlined />
                                        </div>

                                    </div>

                                    <div className={`history-hidden-box ${index === active ? 'history-hidden-box-active' : ''}`}>

                                        {jackpot ?
                                            <div className="history-jackpot-banner">
                                                <div className="history-jackpot-label">ВЫ ВЫИГРАЛИ</div>
                                                <div className="history-jackpot-word">JACKPOT</div>
                                                <div className="history-jackpot-sum">{utils.convertor(jackpot.total, jackpot.currency)}</div>
                                                <div className="history-jackpot-sub">Рояль флеш на бонусе{jackpot.box ? ` · BOX - ${jackpot.box}` : ''}</div>
                                            </div>
                                            : null}

                                        {item.dealer ? <div className="history-dealer">Дилер: {item.dealer}</div> : null}

                                        {item.endReason ? <div className="history-reason-error">{item.endReason}</div> : null}

                                        {(item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) &&
                                            <div className="history-transactions">
                                                {/* <div className="history-transaction-text">Транзакции</div> */}

                                                {(item.startBalance !== null || item.startBalance !== undefined) && <div className="history-transaction-balance">Баланс до игры: {utils.convertor(item.startBalance, item.transactions[0].currency)}</div>}

                                                {item.transactions.map((transaction, tk) => {

                                                    if (transaction.type === 'credit') {
                                                        endBalance = endBalance + parseFloat(transaction.total)
                                                    }

                                                    if (transaction.type === 'debit') {
                                                        endBalance = endBalance - parseFloat(transaction.total)
                                                    }

                                                    return null

                                                    // return (
                                                    //     <div className="history-transaction-item" key={`${tk}`}>
                                                    //         <div className="history-transaction-reason">{transaction.reason} {(transaction.box && parseInt(transaction.box) > 0) ? `(BOX ${transaction.box})` : ''}</div>
                                                    //         <div className={`history-transaction-price ${transaction.type === 'credit' ? 'history-transaction-green-price' : ''}`}> {transaction.type === 'credit' ? "+" : "-"} {utils.convertor(transaction.total, transaction.currency)}</div>
                                                    //         <div className="history-transaction-time">{moment(transaction.createdAt).format("Do MMM YYYY, hh:mm")}</div>
                                                    //     </div>
                                                    // )
                                                })}

                                                {endBalance > 0 && <div className="history-transaction-balance">Баланс после игры: {utils.convertor(endBalance, item.transactions[0].currency)}</div>}

                                            </div>
                                        }

                                        {this.adminRefundList(item)}

                                        {this.operationsList(item)}

                                        {this._cards(item.results, item.cards)}

                                    </div>
                                </div>
                            )
                        })}

                        {historyHasMore &&
                            <div className={`modal-bottom ${bottomStyle}`}>
                                <div className="modal-load-more" onClick={() => loadMore()}>Загрузить еще</div>
                            </div>
                        }

                        <div className="modal-bottom-space" />

                    </div>
                </div>
            </div>

        )

    }

}

export default History